import React, {useEffect, useState} from "react";
import Button from "react-bootstrap/Button";
import axios from "axios";
import apiUrl from "../../../shared/config";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {Close} from "@material-ui/icons";
import Form from "react-bootstrap/Form";
import Popover from "react-bootstrap/Popover";
import Spinner from 'react-bootstrap/Spinner';


export default function SubmitButtonWarning({token, handleSubmit, submitButton, userId, failMessage, showFailMessage, setShowFailMessage, postType, placement = 'bottom'}) {
    const [contactEmail, updateContactEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        window.dispatchEvent(new Event('resize'));
    }, [failMessage]);

    function handleUpdateContactEmail() {

        let data = {};
        setIsLoading(true)

        axios.get(apiUrl + "Users/getUserById?user_id=" + userId + "&token=" + token)
            .then(response => {
                console.log('Get successful:', response.data);
                data = response.data;
                if (!data['user_contact_email']) {
                    data['user_contact_email'] = contactEmail;
                }
                data['share_contact_email'] = 1;
                axios.post(apiUrl + "Users/set?token=" + token, data)
                    .then(response => {
                        console.log('Post successful:', response.data);
                        handleSubmit();
                    });
            })
            .catch(error => {
                console.error('There was an error!', error);
            });

    }

    const close_popover_button =
        <Close
            style={{height: "15px", width: "15px", color: "grey", marginLeft: 20}}
            onClick={() => setShowFailMessage(false)}
        />

    function getFailMessage() {
        switch(failMessage) {
            case "NO_CONTACT_EMAIL":
                return (
                    <div>
                        <div style={{color: "firebrick", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "10px"}}>
                            <b>You must have a contact email in order to add {postType.lowercase}</b>{close_popover_button}
                        </div>
                        <Form.Control
                            type="text"
                            placeholder="Enter contact email"
                            value={contactEmail}
                            onChange={(event) => updateContactEmail(event.target.value)}
                        />
                        <Button
                            onClick={() => {handleUpdateContactEmail()}}
                            style={{marginTop: 10, marginBottom: 10, marginRight: 10, float: "right"}}
                        >
                            Add Email and Submit {postType.capital}
                        </Button>
                        {isLoading &&
                            <Spinner
                                animation="border"
                                style={{width: 30, height: 30, float: "right", marginTop: 14, marginRight: 10}}
                            />}
                    </div>)
            case "UNSHARED_CONTACT_EMAIL":
                return (
                    <div>
                        <div style={{color: "firebrick", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <b>You must have your contact email shared in order to add {postType.lowercase}</b>{close_popover_button}
                        </div>
                        <Button
                            onClick={() => {handleUpdateContactEmail()}}
                            style={{marginTop: 10, marginBottom: 10, marginRight: 10, float: "right"}}
                        >
                            Share Email and Submit {postType.capital}
                        </Button>
                        {isLoading &&
                            <Spinner
                                animation="border"
                                style={{width: 30, height: 30, float: "right", marginRight: 10}}
                            />}
                    </div>)
            case "EMPTY_FIELD":
                return (
                    <div>
                        <div style={{color: "firebrick", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <b>{postType.capitalLowercase} cannot have empty fields</b>{close_popover_button}
                        </div>
                    </div>)
            case "NOT_LOGGED_IN":
                // will display the login modal instead
                return (
                    <div>
                        <div style={{color: "firebrick", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <b>You must be logged in to add {postType.lowercase}</b>{close_popover_button}
                        </div>
                    </div>)
            case "DUPLICATE_ENTRY":
                return (
                    <div>
                        <div style={{color: "firebrick", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <b>{postType.capitalLowercase} already exists with the given title</b>{close_popover_button}
                        </div>
                    </div>)
            case "ALREADY_SUBMITTED":
                return (
                    <div>
                        <div style={{color: "firebrick", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <b>{postType.capitalLowercase} already submitted</b>{close_popover_button}
                        </div>
                    </div>)
            default:
                return (
                    <div>
                        <div style={{color: "firebrick", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <b>Error Adding {postType.capital}</b>{close_popover_button}
                        </div>
                    </div>)
        }
    }


    return <OverlayTrigger
        trigger="click"
        rootClose
        rootCloseEvent="click"
        placement={placement}
        show={showFailMessage}
        onToggle={() => setShowFailMessage(false)}
        overlay={<Popover
            id={"comment-fail-message"}
            placement={placement}
            show={showFailMessage}
            style={{maxWidth: "none", maxHeight: "none", alignItems: "center", textAlign: "center"}}
        >
            <Popover.Content>
                {getFailMessage()}
            </Popover.Content>
        </Popover>}
    >
        {submitButton}
    </OverlayTrigger>

}